/** External dependencies */
// import { Handlebars } from 'handlebars/runtime';

/** Internal dependencies */
import { showItem } from './utilities';

/**
 * Update the items displayed in the results section of the parent
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @export
 *
 * @param {HTMLElement} parent Parent element
 * @param {Object} result API response, parsed JSON
 */
export function updateItems(parent, result) {
    const { ctRestInstance } = parent.dataset;
    const items = result.data;
    const itemsContainer = parent.querySelector(`[data-ct-items="${ctRestInstance}"]`);
    const tmpl = parent.getAttribute('data-ct-tmpl');

    // This function is only called if `result` is an array
    // loop over all items returned from the API
    items.forEach((item) => {
        // Generate html based on data and the Handlebars template
        const html = Handlebars.partials[tmpl](item);

        // Insert the new item at the end of the itemsContainer
        itemsContainer.insertAdjacentHTML('beforeend', html);

        window.lazyLoadInstance.update();

        if (item.id) {
            const itemUpdatedEvent = new CustomEvent('ct.itemUpdated', {
                bubbles: true,
                detail: { item },
            });

            showItem(ctRestInstance, item.id);
            parent.querySelector(`[data-ct-item="${item.id}"]`)?.dispatchEvent(itemUpdatedEvent);
        }
    });
}
